// extracted by mini-css-extract-plugin
export default {"retBarcodeContainer":"RET_retBarcodeContainer__A4yj5","placeHolder":"RET_placeHolder__aG9ZN"};